// Caja de regalo (Corazón Santo)
// Quando o checkbox está marcado, intercepta o envio do formulário de compra e adiciona
// joia + caixa numa única chamada, como duas linhas do carrinho. Depois dispara o mesmo
// evento que o tema usa, para o drawer abrir e re-renderizar.
import { CartAddEvent, CartErrorEvent } from '@theme/events';

const SELECTOR = 'input[data-cs-giftbox]';

if (!window.__csGiftBoxBound) {
  window.__csGiftBoxBound = true;

  // capture no window: roda ANTES do listener de submit do tema (que fica no document)
  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;

      const box = document.querySelector(`${SELECTOR}[data-form-id="${form.getAttribute("id")}"]`);
      if (!box || !box.checked) return; // fluxo normal do tema

      event.preventDefault();
      event.stopImmediatePropagation();
      addWithGiftBox(form, box);
    },
    { capture: true }
  );
}

async function addWithGiftBox(form, box) {
  const component = form.closest('product-form-component');
  const formData = new FormData(form);
  const id = Number(formData.get('id'));
  const quantity = Number(formData.get('quantity')) || 1;

  const item = { id, quantity };
  const properties = {};
  for (const [key, value] of formData.entries()) {
    const m = key.match(/^properties\[(.+)\]$/);
    if (m && value !== '') properties[m[1]] = value;
  }
  if (Object.keys(properties).length) item.properties = properties;
  const sellingPlan = formData.get('selling_plan');
  if (sellingPlan) item.selling_plan = Number(sellingPlan);

  const body = { items: [item, { id: Number(box.dataset.variantId), quantity: 1 }] };

  const sections = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sections.length) {
    body.sections = sections.join(',');
    body.sections_url = window.location.pathname;
  }

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    const target = component || document;

    if (data.status) {
      target.dispatchEvent(new CartErrorEvent(form.getAttribute("id"), data.message, data.description, data.errors));
      return;
    }

    target.dispatchEvent(
      new CartAddEvent({}, String(id), {
        source: 'product-form-component',
        itemCount: quantity,
        productId: component?.dataset.productId,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error('[cs-gift-box]', error);
  }
}
